export { default as ProductAttributeList } from './ProductAttributeList';
export { default as ProductAttributeEdit } from './ProductAttributeEdit';
export { default as ProductAttributeCreate } from './ProductAttributeCreate';


// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/pages/index.ts